<script setup>
import { getProfessionStatus } from '@/helpers'

const props = defineProps({
  entity: {
    type: Object,
    default: () => {}
  }
})

const { t } = useI18n()
const localePath = useLocalePath()

const formattedEntity = reactive({
  id: null,
  type: null,
  name: null,
  bio: null,
  image: null,
  rating: null,
  avg_price: null,
  link: null,
  popover: null,
  specialisations: null,
})

const handleEntity = () => {
  const entityType = props.entity.entity_type

  if (entityType === 'firm')
    formattedEntity.type = entityType
  else
    formattedEntity.type = getProfessionStatus(props.entity.lawyer_profession_status)

  const { hourly_consultation_price, min_hourly_rate, max_hourly_rate } = props.entity
  const lawyerHourlyRate = hourly_consultation_price ? hourly_consultation_price : '- '
  const firmHourlyRate = min_hourly_rate && max_hourly_rate 
  ? min_hourly_rate === max_hourly_rate 
    ? min_hourly_rate 
    : `${min_hourly_rate} - ${max_hourly_rate}` 
  : '- '

  formattedEntity.name = ({
    lawyer: `${props.entity.name} ${props.entity.lastname}`,
    firm: props.entity.name
  })[entityType]

  formattedEntity.bio = ({
    lawyer: getLawyerSectors(props.entity),
    firm: props.entity.address ? `${t('location')}: ${props.entity.address}` : ''
  })[entityType]

  formattedEntity.image = ({
    lawyer: props.entity.photo,
    firm: props.entity.logo
  })[entityType]

  formattedEntity.rating = ({
    lawyer: props.entity.active_reviews_rating,
    firm: props.entity.average_rating ?? 0
  })[entityType]

  formattedEntity.avg_price = ({
    lawyer: `${lawyerHourlyRate}€`,
    firm: `${firmHourlyRate}€`
  })[entityType]

  formattedEntity.link = localePath({ name: `${entityType}-slug`, params: { slug: props.entity.slug } })
  formattedEntity.id = `${entityType}_${props.entity.id}`
  formattedEntity.specialisations = Array.isArray(props.entity.lawyer_specialisations)? sortSpecialisations(props.entity.lawyer_specialisations) : null
}

const sortSpecialisations = (list) => {
  if (!Array.isArray(list)) return []
  return [...list].sort(
    (a, b) =>
      Number(b?.percentage_of_experience ?? -Infinity) -
      Number(a?.percentage_of_experience ?? -Infinity)
  )
}

const getLawyerSectors = ({ business_sectors }) => {
  if (business_sectors && typeof business_sectors === 'object' && !Array.isArray(business_sectors)) {
    const sectorArray = Object.values(business_sectors)
    return sectorArray.slice(0, 5).join(', ')
  }

  return ''
}

handleEntity()
</script>

<template>
  <slot v-bind="formattedEntity" />
</template>